<template lang="pug">
div(v-bind="attributes" :is="block.tagName")
  LazyMediaText(
    v-if="block.type === CORE_MEDIA_TEXT"
    :block="block"
    :lazy="lazy")
  LazyFaqsOriginal(
    v-else-if="patternCheck(block.attributes, FAQS_WRAPPER)"
    :block="block")
  LazyTrustpilotReviews(
    v-else-if="patternCheck(block.attributes, TRUSTPILOT_REVIEWS)"
    :block="block")
  LazyAvFaqs(
    v-else-if="patternCheck(block.attributes, AV_FAQ) || patternCheck(block.attributes, AV_FAQ_OLD)"
    :dynamic-content="patternCheck(block.attributes, AV_DYNAMIC_FAQ_CONTENT)"
    :block="block")
  LazyPageTileNavigation(
    v-else-if="patternCheck(block.attributes, PAGE_TILE_NAVIGATION_FULL_IMAGE)"
    :block="block" :block-id="blockId" :full-image="true")
  LazyPageTileNavigation(
    v-else-if="patternCheck(block.attributes, PAGE_TILE_NAVIGATION)"
    :block="block" :block-id="blockId")
  LazyAvBreadcrumbs(
    v-else-if="isRebrand && patternCheck(block.attributes, BREADCRUMBS)"
    :block="block")
  LazyBreadcrumbs(
    v-else-if="patternCheck(block.attributes, BREADCRUMBS)"
    :block="block")
  Block(
    v-else
    v-for="(innerBlock, key) in block.innerBlocks"
    :key="`wrapperBlock${key}`"
    :block="innerBlock"
    :block-id="blockId"
    :depth="depth")
</template>

<script lang="ts">
import { defineComponent } from "vue"
import { patternCheck, getAttributes } from "~/utils/block"
import {
  AV_FAQ,
  AV_FAQ_OLD,
  AV_DYNAMIC_FAQ_CONTENT,
  BREADCRUMBS,
  CORE_MEDIA_TEXT,
  CORE_QUERY,
  FAQS_WRAPPER,
  PAGE_TILE_NAVIGATION,
  PAGE_TILE_NAVIGATION_FULL_IMAGE,
  TRUSTPILOT_REVIEWS
} from "~/constants/blocks"

export default defineComponent({
  name: "WrapperBlock",

  props: {
    block: {
      type: Object as () => Block,
      required: true
    },
    blockId: {
      type: String,
      required: true
    },
    virgin: {
      type: Boolean,
      default: false
    },
    lazy: {
      type: Boolean,
      default: true
    },
    isRebrand: {
      type: Boolean,
      default: false
    },
    depth: {
      type: Number,
      default: 0
    }
  },

  data() {
    return {
      AV_FAQ,
      AV_FAQ_OLD,
      AV_DYNAMIC_FAQ_CONTENT,
      BREADCRUMBS,
      CORE_MEDIA_TEXT,
      CORE_QUERY,
      FAQS_WRAPPER,
      PAGE_TILE_NAVIGATION,
      PAGE_TILE_NAVIGATION_FULL_IMAGE,
      TRUSTPILOT_REVIEWS
    }
  },

  computed: {
    attributes(): Record<string, any> | null {
      return this.virgin ? null : this.getAttributes(this.block)
    }
  },

  methods: {
    patternCheck,
    getAttributes
  }
})
</script>
